import { useState, useEffect } from 'react';
import { fetchAdminLogs } from '@/api';
import { LoadingPage } from '@/components/common/Loading';
import { Badge } from '@/components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { FileText } from 'lucide-react';
import { formatDateTime } from '@/lib/formatters';

export default function LogsPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [level, setLevel] = useState('');

  useEffect(() => {
    setLoading(true);
    fetchAdminLogs({ level: level || undefined, limit: 50 })
      .then(res => { setLogs(res.data.logs || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [level]);

  return (
    <div data-testid="logs-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold tracking-tight uppercase text-slate-50" style={{ fontFamily: 'var(--font-heading)' }}>
          <FileText className="w-5 h-5 inline mr-2 text-blue-400" />
          System Logs
        </h1>
        <Select value={level} onValueChange={v => setLevel(v === 'all' ? '' : v)}>
          <SelectTrigger className="w-[120px] bg-slate-900 border-slate-700 text-sm">
            <SelectValue placeholder="All Levels" />
          </SelectTrigger>
          <SelectContent className="bg-slate-900 border-slate-700">
            <SelectItem value="all">All Levels</SelectItem>
            <SelectItem value="info">Info</SelectItem>
            <SelectItem value="warning">Warning</SelectItem>
            <SelectItem value="error">Error</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {loading ? <LoadingPage /> : (
        <div className="space-y-1">
          {logs.length > 0 ? logs.map((log, i) => {
            const levelColor = { info: 'bg-blue-500/10 text-blue-400', warning: 'bg-amber-500/10 text-amber-400', error: 'bg-red-500/10 text-red-400' };
            return (
              <div key={i} className="bg-slate-900/50 border border-slate-800 rounded-lg p-3 text-sm">
                <div className="flex items-center gap-2 mb-1">
                  <Badge className={`text-xs ${levelColor[log.level] || 'bg-slate-800 text-slate-400'}`}>{log.level}</Badge>
                  <span className="text-xs text-slate-500">{log.module}</span>
                  <span className="text-xs text-slate-600 ml-auto">{formatDateTime(log.created_at)}</span>
                </div>
                <p className="text-slate-300 text-xs">{log.message}</p>
              </div>
            );
          }) : (
            <div className="text-center py-12 text-slate-500">No logs found</div>
          )}
        </div>
      )}
    </div>
  );
}
